import React from "react";
import PermitApprovers from "../PermitApprovers";
import { pcInOutPermitSupportingDocuments, WorkPermitApprover } from "../../../constants/common";
import PermitDetails from "./PermitDetails";
import SupportingDocuments from "../SupportingDocuments";
import Wrapper from "../Wrapper";

interface PCInOutPermitPDFProps {
  permitDetails: {
    employeeName: string;
    s_Building: string;
    s_LaptopType: string;
    s_LaptopSerialNumber: string;
    dt_PermitStartDate: string;
    dt_PermitEndDate: string;
    haveUserCardFile: number;
    approvers: WorkPermitApprover[];
  };
}

const PCInOutPermitPDF: React.FC<PCInOutPermitPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title="PC In/Out Permit">
      <PermitDetails permitDetails={permitDetails} />
      <SupportingDocuments sectionNumber={2} permitDetails={permitDetails} documents={pcInOutPermitSupportingDocuments} />
      <PermitApprovers sectionNumber={3} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default PCInOutPermitPDF;
